import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Footer from './components/sitePages/Footer';
import Layout from './components/sitePages/Layout';
import './styles/site.scss';
import CircularProgress from '@mui/material/CircularProgress';
import { store } from './app-state/Store';
import { Provider } from 'react-redux';

const App = (): JSX.Element => {
  return (
    <div className='site-wrapper'>
      <Provider store={store}>
        <BrowserRouter>
          <main className='flex-row'>
            <Suspense
              fallback={
                <div className='loading-container'>
                  <CircularProgress />
                </div>
              }>
              <Layout />
            </Suspense>
          </main>
          <Footer />
        </BrowserRouter>
      </Provider>
    </div>
  );
};

export default App;
